import { create } from "zustand";

const STORAGE_KEYS = {
  APPLICATIONS: "nspo_job_applications",
  INVESTORS: "nspo_investor_submissions",
  LANGUAGE: "nspo_language",
  THEME: "nspo_theme",
};

export const useStore = create((set, get) => ({
  // Language and theme
  language: localStorage.getItem(STORAGE_KEYS.LANGUAGE) || "ar",
  theme: localStorage.getItem(STORAGE_KEYS.THEME) || "light",

  // Seed data
  seedData: null,

  // Global loading state
  isGlobalLoading: false,

  // Applications and submissions
  applications: JSON.parse(
    localStorage.getItem(STORAGE_KEYS.APPLICATIONS) || "[]"
  ),
  investors: JSON.parse(localStorage.getItem(STORAGE_KEYS.INVESTORS) || "[]"),

  // Actions
  setLanguage: (language) => {
    localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
    set({ language });
  },

  setTheme: (theme) => {
    localStorage.setItem(STORAGE_KEYS.THEME, theme);
    set({ theme });
  },

  setSeedData: (data) => set({ seedData: data }),

  setGlobalLoading: (isLoading) => set({ isGlobalLoading: isLoading }),

  addApplication: (application) => {
    const applications = [
      ...get().applications,
      {
        ...application,
        id: Date.now().toString(),
        status: "pending",
        submittedAt: new Date().toISOString(),
      },
    ];
    localStorage.setItem(
      STORAGE_KEYS.APPLICATIONS,
      JSON.stringify(applications)
    );
    set({ applications });
  },

  addInvestor: (investor) => {
    const investors = [
      ...get().investors,
      {
        ...investor,
        id: Date.now().toString(),
        status: "pending",
        submittedAt: new Date().toISOString(),
      },
    ];
    localStorage.setItem(STORAGE_KEYS.INVESTORS, JSON.stringify(investors));
    set({ investors });
  },

  updateApplicationStatus: (id, status) => {
    const applications = get().applications.map((app) =>
      app.id === id ? { ...app, status } : app
    );
    localStorage.setItem(
      STORAGE_KEYS.APPLICATIONS,
      JSON.stringify(applications)
    );
    set({ applications });
  },

  updateInvestorStatus: (id, status) => {
    const investors = get().investors.map((inv) =>
      inv.id === id ? { ...inv, status } : inv
    );
    localStorage.setItem(STORAGE_KEYS.INVESTORS, JSON.stringify(investors));
    set({ investors });
  },

  resetToSeed: () => {
    localStorage.removeItem(STORAGE_KEYS.APPLICATIONS);
    localStorage.removeItem(STORAGE_KEYS.INVESTORS);
    set({ applications: [], investors: [] });
  },
}));
